module.exports = __webpack_public_path__ + "static/media/trustpilot.8b6df1ef.svg";